import { cn } from "@/lib/utils";
import { ComponentPropsWithoutRef, forwardRef } from "react";

export const FormDescription = forwardRef<HTMLParagraphElement, ComponentPropsWithoutRef<"p">>(
  ({ className, ...props }, ref) => (
    <p ref={ref} {...props} className={cn("fs-18 text-text-secondary mb-0 font-medium")} />
  ),
);

export default FormDescription;
